<template>
    <div class="human">
        <div class="title">{{ title }}</div>
        <div class="formitem" v-for="(item, i) in formdata" :key="i">
            <div class="form-head"><img :src="item.value ? (headurl + item.value) : defaultimg" alt="" class="user-avatar" v-if="item.key == 'head_pic'">{{ item.name }}</div>
            <div class="form-content" v-if="!specialKey.includes(item.key)">{{ item.value || `暂无${item.name}数据` }}</div>
            <div class="form-content" v-if="item.key == 'head_pic'">支持2M以内的JPG或PNG格式图片</div>
            <el-button class="form-btn" v-if="item.key !== 'id'" @click="humanedit(i)">{{ `编辑${item.name}`
                }}</el-button>
            <div class="form-content" v-if="item.key == 'password'">******</div>
        </div>
        <el-dialog :visible="logvisible" @close="closevisible" width="470px" v-if="logvisible" custom-class="human-log" :close-on-click-modal="false">
            <div slot="title" class="dialog-title">{{ `编辑${selectdata.name}` }}</div>
            <div v-if="selectdata.key !== 'head_pic'">
                <div class="title-small">
                    原{{ selectdata.name }}
                </div>
                <el-input v-if="selectdata.key !== 'password'" disabled  :value="selectdata.value" class="form-input"></el-input>
                <el-input v-else v-model="prePwd" class="form-input" placeholder="请输入原密码"></el-input>
                <div class="title-small">
                    新{{ selectdata.name }}
                </div>
                <el-input v-model="editvalue" :placeholder="`请输入新的${selectdata.name}`" class="form-input">
                </el-input>
            </div>
            <div v-else class="upload-demo">
                <el-upload :action="headurl + loadurl" list-type="picture-card"
                    multiple :show-file-list="false" v-if="selectdata.key == 'head_pic'" :headers="upheader" :on-success="upsuccess">
                    <div class="img_add_box">
                        <div class="img_add_btn">
                            <el-image class="img_add_icon" :src="addicon" fit="contain" />
                        </div>
                    </div>
                </el-upload>
                <div class="avater-img" v-if="selectdata.key == 'head_pic'">
                    <img :src="selectdata.value ? (headurl + selectdata.value) : defaultimg" />
                </div>
            </div>
            <div class="btn-group">
                <el-button class="btn-item" @click="closevisible">取消</el-button>
                <el-button class="btn-item" type="primary" @click="updataUser">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getUserinfo, updateUserinfo, changePwd } from '@/api/new'
import defaultimg from '@/assets/human/default-avatar.png'
import addicon from '@/assets/human/add.png'

export default {
    name: 'human',
    data() {
        return {
            addicon,
            defaultimg,
            title: '账号设置',
            formdata: [
                { name: '用户名', value: '', key: 'nickname' },
                { name: '头像', value: '', key: 'head_pic' },
                // { name: '用户ID', value: '', key: 'id' },
                { name: '企业名', value: '', key: 'company_name' },
                { name: '手机号', value: '', key: 'mobile' },
                { name: '微信', value: '', key: 'wx_account' },
                { name: '密码', value: '', key: 'password' },
            ],
            specialKey: ['head_pic', 'password'],
            userinfo: {},
            logvisible: false,
            selectdata: {},
            editvalue: '',
            imgAdd: '',
            avater: '',
            headurl: process.env.VUE_APP_BASE_API,
            loadurl: '/apiuser/UserUpload/index/savepath/user/action/uploadimage/pictitle/banner/dir/images',
            upheader: {
                token: ''
            },
            prePwd: ''
        }
    },
    methods: {
        humanedit(index) {
            this.selectdata = JSON.parse(JSON.stringify(this.formdata[index]))
            this.logvisible = true
        },
        closevisible() {
            this.logvisible = false
            this.editvalue = ''
            this.prePwd = ''
        },
        getUser() {
            getUserinfo().then(res => {
                if (res.status == 200) {
                    this.userinfo = res.data
                    this.formdata.forEach(item => {
                        item.value = this.userinfo[item.key] || ''
                    })
                }
            })
        },
        updataUser() {
            if (this.selectdata.key == 'password') {
                this.changepass()
                return
            }
            this.userinfo[this.selectdata.key] = this.editvalue
            if (this.selectdata.key == 'head_pic') {
                this.userinfo.head_pic = this.selectdata.value
            }
            updateUserinfo(this.userinfo).then(res => {
                if (res.status == 200) {
                    this.$message.success('修改信息成功')
                    this.logvisible = false
                    localStorage.setItem('userInfor', JSON.stringify(this.userinfo))
                    let index = this.formdata.findIndex(item => item.key == this.selectdata.key)
                    this.formdata[index].value = this.editvalue || this.selectdata.value
                    this.editvalue = ''
                    this.$emit('updatainfo')
                }
            })
        },
        upsuccess(img) {
            if (img.url) {
                this.selectdata.value = img.url
            }
        },
        changepass() {
            const params = {
                old_pwd: this.prePwd,
                new_pwd: this.editvalue
            }
            changePwd(params).then(res => {
                if(res.status == 200) {
                    this.$message.success(res.msg)
                    this.closevisible()
                } else {
                    this.$message.warning(res.msg)
                }
            })
        }
    },
    mounted() {
        this.getUser()
        let token = localStorage.getItem('token')
        this.upheader.token = token
    }
}
</script>

<style lang="scss" scoped>
.human {
    padding: 74px 80px 0 80px;
    width: 1220px;
    height: calc(100% - 74px);
    background: #fff;

    .title {
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 21px;
        color: #272C32;
    }

    .formitem {
        margin-top: 24px;
        border-bottom: 1px solid #EAECEE;
        padding-bottom: 24px;
        position: relative;
    }

    .form-head {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #272C32;
    }

    .form-content {
        margin-top: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #656B73;
    }

    .form-btn {
        position: absolute;
        right: 0;
        top: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #272C32;
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.title-small {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 14px;
    color: #272C32;
    line-height: 26px;
}

.title-small+.form-input {
    margin-top: 16px;
}

.form-input+.title-small {
    margin-top: 26px;
}

.btn-group {
    display: flex;
    align-items: center;
    column-gap: 12px;
    margin-top: 26px;

    .btn-item {
        flex: 1;
    }
}
.user-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 12px;
}
.dialog-title {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #272C32;
    line-height: 26px;
}
.img_add_box {
  height: 100%;
  .img_add_icon {
    width: 32px;
    height: 32px;
  }
}
.upload-demo {
    display: flex;
    align-items: center;
}
.avater-img {
    width: 146px;
    height: 146px;
    border-radius: 50%;
    margin-left: 32px;
    overflow: hidden;
    img {
        width: 100%;
        height: 100%;
    }
}
</style>
<style lang="scss">
.human-log {
    .el-dialog__body {
        padding-top: 16px;
    }
}
</style>